/**
 * The console's filters, read from the URL it was opened with.
 *
 * Several things link into the console expecting a particular queue: the
 * submission email with `?campaign_id=`, and a finance notice with
 * `?status=approved`. A link that lands on the right page but the wrong list
 * is a worse dead end than no link, because it looks like it worked.
 *
 * Nothing here trusts the query string. An unrecognised status is dropped
 * rather than applied — filtering to an empty screen on a typo or a stale
 * bookmark is worse than ignoring the parameter and showing everything.
 *
 * `allowed` is supplied by the caller, which already knows which statuses it
 * can display, so the two can never drift apart.
 */

/** `{status, campaign_id}` — each `''` when absent, malformed or unknown. */
export function filtersFromSearch(search, allowed) {
  let params;
  try {
    params = new URLSearchParams(String(search || ''));
  } catch (e) {
    return { status: '', campaign_id: '' };
  }

  const known = (Array.isArray(allowed) ? allowed : []).filter(Boolean);
  const status = params.get('status') || '';
  const campaignId = params.get('campaign_id') || '';

  return {
    status: known.includes(status) ? status : '',
    // Ids are numeric; anything else came from a mangled link.
    campaign_id: /^\d+$/.test(campaignId) ? campaignId : '',
  };
}
